{
  "errors": {
    "failedToLoad": "Det gick inte att ladda egna uppgifter",
    "unexpectedError": "Ett oväntat fel inträffade",
    "updateFailed": "Det gick inte att uppdatera kontaktuppgifterna. Försök igen senare."
  },
  "contractDocument": {
    "header": "Avtal",
    "errors": {
      "failedToOpen": "Det gick inte att öppna avtalsdokumentet. Försök igen senare."
    }
  }
}
